module.exports = {
      id: "search-white-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#search-white",
      toString: function () {
        return this.url;
      }
    }